import {initPage} from "./init-page";
import {renderNewsPage} from "./render-news-page";

window.addEventListener(`load`, () => {
  initPage();
  renderNewsPage(newsList);
});
